import { useTranslation } from "react-i18next";

const EmployeeRoleOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "ADMIN",
      title: t("options.employeeRole.admin"),
      value: "ADMIN",
    },
    {
      key: "TOP",
      title: t("options.employeeRole.top"),
      value: "TOP",
    },
    {
      key: "USER",
      title: t("options.employeeRole.user"),
      value: "USER",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default EmployeeRoleOptions;
